// extracted by mini-css-extract-plugin
module.exports = {"title":"styles_title__2m5LO","content":"styles_content__IRy4W"};